<template>
    <div>
        <multiselect
            :max-height="max_height ? max_height : 300"
            :id="id"
            :loading="isLoading"
            v-model="legal_owner"
            tag-placeholder=""
            placeholder=""
            :options="legal_owner_select_only_active"
            :close-on-select="true"
            :clear-on-select="false"
            label="title" track-by="id"
            :taggable="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            :showNoOptions="false"
            :searchable="true"
            :disabled="disabled"
            group-values="items"
            group-label="group_name"

            :internal-search="filter_category !== 'request'"
            @search-change="asyncFind"
        >
            <template slot="option" slot-scope="props">
                <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>

                <a v-if="props.option.platform_id !== 0 ? ($hasPermission('counteragents.update') && props.option.id && filter_category !== 'request' && filter_category !== 'staff') : ($hasPermission('counteragents.generals.update') && props.option.id)" @click="showEdit(props.option.id)" class="small text-muted">{{props.option.$groupLabel}} редактировать</a>
            </template>
            <template slot="beforeList" v-if="$hasPermission('counteragents.create') && filter_category !== 'request' && filter_category !== 'staff'">
                <li class="multiselect__element"><span class="multiselect__option"><a @click="showCreate()" class="option__title">Добавить</a></span></li>
            </template>
        </multiselect>
        <el-dialog :title="form_mode === 'create' ? 'Создание контрагента' : 'Редактирование контрагента'" :visible.sync="form_state" width="450px" :append-to-body="true">
            <CounteragentForm v-if="form_state" :mode="form_mode" :obj="form_owner" @created="onCreated" @updated="onUpdated"/>
        </el-dialog>
    </div>
</template>

<script>
import CounteragentForm from "./CounteragentForm";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
export default {
    name: "CounteragentSelect",
    components: {CounteragentForm,Multiselect},
    props: ['value', 'id', 'filter_type', 'filter_category', 'init_value', 'filter_platforms', 'filter_without_generals', 'filter_request', 'disabled', 'max_height'],
    data: () => ({
        legal_owner: null,
        legal_owners: [],

        form_state: false,
        form_mode: null,
        form_owner: null,
        isLoading: false,
        options_ajax_find: [],
    }),
    mounted() {
        let self = this;

        this.isLoading = true;
        axios.get('/api/counteragents', {
            params: this.filter_request,
        })
            .then(response => {
                self.legal_owners = response.data;
                self.isLoading = false;

                self.legal_owner_select.forEach(group => {
                    group.items.forEach(item => {
                        if (+item.id === +self.value) self.legal_owner = item;
                    })
                })
            });
    },
    watch: {
        legal_owner(val) {
            this.$emit('input', val ? val.id : null);
        },
        value(val) {
            if (this.init_value && this.init_value.id === this.value) this.legal_owner = this.init_value;
            let self = this;
            let i = setInterval(() => {
                if (self.isLoading === false) {
                    clearInterval(i);
                    self.legal_owner_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +val) self.legal_owner = item;
                        })
                    })
                }
            }, 1000)
        }
    },
    computed: {
        legal_owner_select_only_active() {
            let data = _.mapValues(this.legal_owner_select, function (item) {
                item.items = _.filter(item.items, 'is_active')
                return item;
            });
            return _.values(data);
        },
        legal_owner_select() {
            let data = {};
            let self = this;
            let options = this.filter_category === 'request' ? _.clone(this.options_ajax_find) : _.clone(this.legal_owners);
            let only_platforms_ids = this.filter_platforms ? this.filter_platforms : null;
            options.forEach(function (item) {
                if (self.filter_type && item.subject_type !== self.filter_type) return;
                if (self.filter_category && item.category !== self.filter_category) return;
                if (only_platforms_ids && !only_platforms_ids.includes(item.platform_id)) return;
                if (self.filter_without_generals && !item.platform_id) return;
                if (!data[item.platform_id]) data[item.platform_id] = {group_name: item.platform_id ? PlatformHelper.get(item.platform_id).name : "Общие", items: []}

                let title = self.$counteragentLabel(item, true);

                data[item.platform_id].items.push({
                    id: item.id,
                    platform_id: item.platform_id,
                    title: title,
                    is_active: !item.user || item.user.is_active,
                });
            });
            data = _.mapValues(data, function (item) {
                item.items = _.sortBy(item.items, ['title'])
                return item;
            });
            return _.values(data);
        }
    },
    methods: {
        asyncFind(query) {
            if (!query || query.length < 3) {
                this.options_ajax_find = [];
                return;
            }
            this.isLoading = true;
            let self = this;
            self.options_ajax_find = [];

            axios.get('/api/counteragents/searchHasRequest?query=' + query)
                .then(response => {
                    self.options_ajax_find = response.data;
                    self.isLoading = false;
                });
        },
        showEdit(id) {
            this.form_mode = 'edit';
            this.form_owner = _.find(this.legal_owners, {id: id});
            this.form_state = true;
        },
        showCreate() {
            this.form_mode = 'create';
            this.form_state = true;
        },
        onCreated(owner) {
            let self = this;
            this.legal_owners.push(owner);
            this.form_state = false;
            this.legal_owner_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.legal_owner = item;
                })
            })
        },
        onUpdated(owner) {
            let self = this;
            this.form_state = false;
            this.legal_owners = this.legal_owners.map(item => {
                if(item.id === owner.id) item = owner;
                return item;
            })
            this.legal_owner_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.legal_owner = item;
                })
            })
        }
    }
}
</script>

<style scoped>

</style>
